class AgeCost < ApplicationRecord
  belongs_to :age
end
